export default {
  title: 'Réinitialiser le mot de passe',
  description: 'Nous vous enverrons un lien de réinitialisation par e-mail.',
  sent: 'E-mail envoyé.',

  form: {
    email: {
      title: 'E-mail',
      placeholder: "Saisir l'e-mail",
    },
    button: {
      title: 'Réinitialiser le mot de passe',
    },
    error_messages: {
      error1: 'Informations manquantes',
    },
  },
};
